import { render, staticRenderFns } from "./OldFormUpload.vue?vue&type=template&id=64780f68&scoped=true"
import script from "./OldFormUpload.vue?vue&type=script&lang=js"
export * from "./OldFormUpload.vue?vue&type=script&lang=js"
import style0 from "./OldFormUpload.vue?vue&type=style&index=0&id=64780f68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64780f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64780f68')) {
      api.createRecord('64780f68', component.options)
    } else {
      api.reload('64780f68', component.options)
    }
    module.hot.accept("./OldFormUpload.vue?vue&type=template&id=64780f68&scoped=true", function () {
      api.rerender('64780f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/OldFormUpload.vue"
export default component.exports